export default __webpack_public_path__ + "static/media/canada-flag.4a312091.svg";